/* Swiper Initialiser */
let swiperPractitioners;
if (typeof Swiper !== 'undefined') {
const swiperContainerP = document.getElementsByClassName(
  'carousel_product'
);
for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add('swiperP' + i);

  const swiperPage = swiperContainerP[i].querySelector(
    '.swiper-pagination'
  );

  if (swiperPage) {
    swiperPage.classList.add('pageP' + i);
  }

  var mySwiperP = new Swiper('.swiperP' + i, {
    direction: 'horizontal',
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    speed: 300,
    centeredSlides: true,
    pagination: {
      el: '.pageP' + i,
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-product-button-next',
      prevEl: '.swiper-product-button-prev'
    }
  });
}

var swiperTestimonialsText = new Swiper('.swiper-testimonials-text', {
  direction: 'vertical',
  slidesPerView: 1,
  loop: true,
  spaceBetween: 10,
  autoplay: {
    delay: 3000
  }
});

var swiperTestimonialsCarousel = new Swiper(
  '.swiper-testimonials-carousel',
  {
    direction: 'horizontal',
    slidesPerView: 1.3,
    centeredSlides: true,
    loop: true,
    spaceBetween: 12,
    navigation: {
      nextEl: '.swiper-testimonials-carousel-button-next',
      prevEl: '.swiper-testimonials-carousel-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        speed: 7000
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 24
      }
    }
  }
);

var swiperRelatedProducts = new Swiper('.swiper-related-products', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  // slidesPerGroup: 3,
  slidesOffsetBefore: 12,
  slidesOffsetAfter: 12,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-related-products-button-next',
    prevEl: '.swiper-related-products-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24
    }
  }
});

// var swiperIngredientsCarousel = new Swiper('.swiper-ingredients-carousel', {
//   direction: 'horizontal',
//   slidesPerView: 2.8,
//   spaceBetween: 24,
// 	// freeMode: true
// });

swiperPractitioners = new Swiper('.swiper-practitioners', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 20,
  slidesOffsetBefore: 12,
  slidesOffsetAfter: 12,
  // slidesPerGroup: 3,
  // loop: true,
  navigation: {
    nextEl: '.swiper-practitioners-button-next',
    prevEl: '.swiper-practitioners-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5
    },
    1024: {
      slidesPerView: 3.5,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24
    }
  }
});

const swiperProductCarousel = new Swiper('.swiper-product-carousel', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 24,
  navigation: {
    nextEl: '.swiper-product-carousel-button-next',
    prevEl: '.swiper-product-carousel-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5
    },
    1024: {
      slidesPerView: 4
    }
  }
});

const swiperArticleCarousel = new Swiper('.swiper-article-carousel', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesOffsetAfter: 12,
  slidesOffsetBefore: 12,
  navigation: {
    nextEl: '.swiper-article-carousel-button-next',
    prevEl: '.swiper-article-carousel-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
      spaceBetween: 12,
      slidesOffsetAfter: 12,
      slidesOffsetBefore: 12
    },
    1024: {
      slidesPerView: 3.105,
      spaceBetween: 24,
      slidesOffsetAfter: 24,
      slidesOffsetBefore: 24
    }
  }
});

const swiperBookingCarousel = new Swiper('.swiper-booking-carousel', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 12,
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 12
    }
  }
});
}

/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const stagger = document.querySelectorAll('.stagger');
const isDesignMode = window.Shopify && Shopify.designMode;

function revealAllInDesignMode(root = document) {
  root.querySelectorAll('.reveal').forEach(el => el.classList.add('entered'));
}

if (reveals.length > 0) {
  if (isDesignMode) {
    revealAllInDesignMode();
    document.addEventListener('shopify:section:load', e => {
      revealAllInDesignMode(e.target);
    });
  } else {
    enterView({
      selector: '.reveal',
      enter: (el, i) => {
        el.classList.add('entered');
      },
      exit: el => {
        el.classList.remove('entered');
      },
      offset: 0.1
    });
  }
}

if (stagger.length > 0) {
  stagger.forEach(el => {
    el.querySelectorAll('.stagger-child').forEach((e, i) => {
      e.style.setProperty('--animation-order', i);
    });
  });
}

// MOBILE VIEWPORT HEIGHT FIX
(() => {
  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  setVh();
  window.addEventListener('resize', setVh);
})();

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

// Treatment Filters
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll(
    '.treatment__button[data-id]'
  );
  const sections = document.querySelectorAll(
    '.treatments-category[data-id]'
  );

  if (!buttons.length || !sections.length) return; // ✅ valid here

  function activateById(id) {
    sections.forEach(section =>
      section.classList.toggle(
        'is-visible',
        section.getAttribute('data-id') === id
      )
    );
    buttons.forEach(btn =>
      btn.classList.toggle(
        'active',
        btn.getAttribute('data-id') === id
      )
    );
  }

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const id = button.getAttribute('data-id');
      activateById(id);
      history.replaceState(null, null, `#${id}`);
    });
  });

  const hash = window.location.hash.replace('#', '');
  const validIds = Array.from(buttons).map(btn =>
    btn.getAttribute('data-id')
  );
  if (hash && validIds.includes(hash)) {
    activateById(hash);
  } else if (buttons.length > 0) {
    activateById(buttons[0].getAttribute('data-id'));
  }

  window.addEventListener('hashchange', () => {
    const newHash = window.location.hash.replace('#', '');
    if (validIds.includes(newHash)) {
      activateById(newHash);
    }
  });
});

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

    console.log('here', button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault();
        targetDetail.classList.add('closing');
        setTimeout(() => {
          targetDetail.removeAttribute('open');
          targetDetail.classList.remove('closing');
        }, 390);
      }
    });
  });
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'a',
  'span'
];
var nbspWordMin = 10; //Minimum words within parent tag to activate script

nbspSelectors.forEach(function (selector) {
  var nbspElements = document.querySelectorAll(selector);
  nbspElements.forEach(function (element) {
    element.innerHTML = element.innerHTML.replace(/\u2028/g, '');
    element.innerHTML = element.innerHTML.replace(/&#8232;/g, '');
    var wordCount = element.innerHTML.split(' ').length;
    if (wordCount >= nbspWordMin) {
      element.innerHTML = element.innerHTML.replace(
        / ([^ ]*)$/,
        '&nbsp;$1'
      );
    }
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'ADDING';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0) {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Navigation
const navigation = document.querySelector('#navigation');
const header = document.querySelector('.header');

const menuItems = Array.from(
  document.querySelectorAll('#headerMenuItem')
);
const childLinks = document.querySelectorAll(
  '.navigation__child-link'
);
const childImages = document.querySelectorAll('.navigation__image');

menuItems.forEach(item => {
  item.addEventListener('mouseenter', e => {
    const navItem = e.currentTarget.dataset.navItem;

    const childLinks = document.querySelector(
      `#navChildMenu[data-nav-item="${navItem}"]`
    );

    menuItems.forEach(menuItem =>
      menuItem.classList.remove('active')
    );

    const activeNavLink = menuItems.find(
      item => item.dataset.navItem == navItem
    );

    const activeNavItem = document.querySelector(
      '#navChildMenu.active'
    );

    if (activeNavItem) {
      activeNavItem.classList.remove('active');
    }

    childLinks.classList.add('active');
    activeNavLink.classList.add('active');
    navigation.classList.add('active');

    // Hover colour
    const hoverTheme = e.currentTarget.dataset.hoverTheme;

    header.classList.forEach(className => {
      if (className.startsWith('theme-')) {
        header.classList.remove(className);
      }
    });

    header.classList.add(`theme-${hoverTheme}`);
  });
});

childLinks.forEach(link => {
  link.addEventListener('mouseenter', e => {
    const navItem = link.getAttribute('data-nav-item');
    const activeImage = document.querySelector(
      `#image-${CSS.escape(navItem)}`
    );

    childImages.forEach(img => img.classList.remove('active'));

    if (activeImage) {
      activeImage.classList.add('active');
    }
  });
});

navigation.addEventListener('mouseleave', e => {
  navigation.classList.remove('active');
  menuItems.forEach(menuItem => menuItem.classList.remove('active'));

  document
    .querySelector('#navChildMenu.active')
    .classList.remove('active');
  childImages.forEach(img => img.classList.remove('active'));
  childImages[0]?.classList.add('active');

  // Hover color
  header.classList.forEach(className => {
    if (className.startsWith('theme-')) {
      header.classList.remove(className);
    }
  });
});

// Announcement Bar
const bodyWrapper = document.querySelector('body');
const announcementBar = document.querySelector('.announcement-bar');

if (announcementBar != null) {
  bodyWrapper.classList.add('announcement-bar-visible');
}

// Image and Link image hover
const links = document.querySelectorAll('.image-and-links__link');
const images = document.querySelectorAll('.image-and-links__image');
const firstImage = document.querySelector(
  '.image-and-links__image[data-image-index="0"]'
);

if (links.length > 0) {
  links.forEach(link => {
    const index = link.getAttribute('data-link-index');

    link.addEventListener('mouseenter', () => {
      links.forEach(l => l.classList.remove('is-active'));
      link.classList.add('is-active');

      images.forEach(img => img.classList.remove('is-visible'));
      const matchedImage = document.querySelector(
        `.image-and-links__image[data-image-index="${index}"]`
      );
      if (matchedImage) matchedImage.classList.add('is-visible');
    });

    link.addEventListener('mouseleave', () => {
      links.forEach(l => l.classList.remove('is-active'));
      if (links[0]) links[0].classList.add('is-active');

      images.forEach(img => img.classList.remove('is-visible'));
      if (firstImage) firstImage.classList.add('is-visible');
    });
  });
}

// Testimonials Video
const pills = document.querySelectorAll('.testimonials-video__pill');
const contents = document.querySelectorAll(
  '.testimonials-video__content'
);
const videos = document.querySelectorAll(
  '.testimonials-video__video'
);

if (pills.length > 0 && contents.length > 0 && videos.length > 0) {
  pills.forEach(pill => {
    pill.addEventListener('mouseenter', handleInteraction);
    pill.addEventListener('click', handleInteraction);
  });

  function applyTestimonialsMuteState() {
    const section = document.querySelector('.testimonials-video');
    if (!section) return;
    const isUnmuted = section.dataset.testimonialsUnmuted === 'true';
    const activeVideoEl = section.querySelector('.testimonials-video__video.active video');
    section.querySelectorAll('video').forEach(v => { v.muted = true; });
    if (isUnmuted && activeVideoEl) activeVideoEl.muted = false;
    section.querySelectorAll('.testimonials-video__mute-toggle').forEach(btn => {
      btn.textContent = isUnmuted ? 'Mute' : 'Unmute';
    });
  }

  function handleInteraction(e) {
    const pill = e.currentTarget;
    const index = pill.getAttribute('data-index');

    pills.forEach(p => p.classList.remove('active'));
    pill.classList.add('active');

    contents.forEach(content => {
      content.classList.toggle(
        'active',
        content.getAttribute('data-index') === index
      );
    });

    videos.forEach(video => {
      video.classList.toggle(
        'active',
        video.getAttribute('data-index') === index
      );
    });

    applyTestimonialsMuteState();
    updateTestimonialsHeight();
  }

  function updateTestimonialsHeight() {
    const leftContainer = document.querySelector(
      '.testimonials-video__details'
    );
    const activeContent = document.querySelector(
      '.testimonials-video__content.active'
    );
    if (!leftContainer || !activeContent) return;

    const contentHeight = activeContent.scrollHeight;
    leftContainer.style.height = contentHeight + 'px';
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateTestimonialsHeight, 300);
  });

  window.addEventListener('load', updateTestimonialsHeight);
  window.addEventListener('resize', updateTestimonialsHeight);
}

// Practitioners
const practitionerButtons = document.querySelectorAll('.expand-btn');

if (practitionerButtons.length > 0 && swiperPractitioners) {
  practitionerButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const slide = btn.closest(
        '.swiper-practitioners .swiper-slide'
      );

      document
        .querySelectorAll('.swiper-practitioners .swiper-slide')
        .forEach(s => {
          if (s !== slide) s.classList.remove('expanded');
        });

      slide.classList.toggle('expanded');

      const index = Array.from(slide.parentNode.children).indexOf(
        slide
      );
      swiperPractitioners.slideTo(index, 300); // scroll to this slide smoothly

      swiperPractitioners.update();
    });
  });
}

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return; // Exit if no account nav on this page

  // Reset all nav links
  links.forEach(link => link.classList.remove('active'));

  // Handle /account page
  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    // Hide all content sections
    sections.forEach(section => section.classList.add('hidden'));

    // Default to #dashboard if no hash
    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    // Add active class to the correct nav link
    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    // If hash was missing, update the URL (only without reloading)
    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  // Handle /account/addresses page
  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

// Run on load and on hash change
document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);
